export default "__VITE_ASSET__DYnKlf0m__"